import { useContext } from "react";
import { AccountContext } from "@context/AccountProvider";

export const RoleBasedComponent = ({ minRole, children, fallback = null }) => {
    const { role } = useContext(AccountContext);

    if (!role) return null; // No role = no access

    return role.level >= minRole.level ? children : fallback;
};

export const RoleWhiteListBasedComponent = ({ whiteList, children, fallback = null }) => {
    const { role } = useContext(AccountContext);

    if (!role) return null; // No role = no access

    // Check if the role's level is in the whitelist
    const isAllowed = whiteList.some(allowedRole => 
        allowedRole.level === role.level
    );

    return isAllowed ? children : fallback;
};